export default "__VITE_ASSET__TuKDM5MQ__"